module.exports = __webpack_public_path__ + "img/feizhougu_20210901113638.ee5c11b5.png";